import { redirect } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { store } from '../../../store';

export async function logoutAction() {
  await Auth.signOut();
  await store.clear();
  return redirect('/login');
}
